import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../../theming/sections.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Status_PartiallyAccepted_getInstancetm1ylzstkb4p as Status_PartiallyAccepted_getInstance,
  Status_Draft_getInstance6tlwzpe7uax3 as Status_Draft_getInstance,
} from '../data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../../theming/colorManagement.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_linked25zbblktmzgbh as get_linked } from '../../../../../../icons.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../../nav/AppDimensions.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../../../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance } from '../../../../../screens/common/ProjectView.mjs';
import { actionIcon360epyywhabwj as actionIcon } from '../../../../iconShortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../../theming/states.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { uppercaseChar6lahngw3wvwg as uppercaseChar } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { toString3o7ifthqydp6e as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { renderPriceChangegxsbuhvani39 as renderPriceChange } from '../../../../priceChanges.mjs';
import { ChangeOrderDetails3bhfjfcpbf0qv as ChangeOrderDetails } from './ChangeOrderDetails.mjs';
import { ChangeOrderForm23hgjlgmtvjevd as ChangeOrderForm2 } from '../ChangeOrderForm2.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function changeOrderCard(_this__u8e3s4, change, writer) {
  // Inline function 'kotlin.with' call
  var tmp = get_lightSection(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp_0 = get_compact(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var tmp_1 = get_centered(view_1);
  view_1.jbb(view_1.ibb(view_1.ibb(tmp_1, shownWhen(view_1, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.let' call
    var it = $this$shownWhen.baj(change);
    return it.eh8_1.d4(Status_PartiallyAccepted_getInstance()) < 0 && it.ch8_1.x57_1;
  })), colored(view_1, AppColors_getInstance().dfz_1.xg9_1)), icon(view_1, resize(get_linked(Companion_getInstance()), times(get_AppDimensions().tg1_1, 1.1)), 'linked'));
  if (_this__u8e3s4.rgj().xgj()) {
    var tmp_2 = get_centered(view_1);
    view_1.jbb(tmp_2, actionIcon(view_1, VOID, ($this$actionIcon) => $this$actionIcon.baj(change).eh8_1.d4(Status_PartiallyAccepted_getInstance()) < 0 ? ActionImportance_Important_getInstance() : null));
  }
  var tmp_3 = view_1.ibb(get_centered(view_1), get_expanding(view_1));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.baj(change).ch8_1;
    var tmp$ret$4 = 'Change #' + it.b58_1 + ': ' + it.s57_1;
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_3, view_2);
  var tmp_6 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  dynamicTheme(view_3, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(change).eh8_1));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_0(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_0(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$11 = $this$reactiveScope.baj(change).eh8_1.zh7_1;
    this_1.set(tmp$ret$11);
    return Unit_instance;
  });
  view_1.fbb(p_3, view_3);
  view_1.jbb(tmp_6, view_3);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
  var $this$body = view_4;
  var str = remember(VOID, VOID, VOID, ($this$remember) => {
    var c = $this$remember.baj(change);
    // Inline function 'kotlin.text.replaceFirstChar' call
    var this_0 = joinToString(listOfNotNull([changeOrderCard$_anonymous_$_anonymous_$_anonymous_$_anonymous_$withUnit_ciuhoc(c.mh8().p1(), '<i>new<\/i> item'), changeOrderCard$_anonymous_$_anonymous_$_anonymous_$_anonymous_$withUnit_ciuhoc(c.gh8_1.p1(), '<i>modified<\/i> item'), changeOrderCard$_anonymous_$_anonymous_$_anonymous_$_anonymous_$withUnit_ciuhoc(c.hh8_1.p1(), '<i>cancelled<\/i> item')]), ', ');
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      var it = charCodeAt(this_0, 0);
      var tmp0 = uppercaseChar(it);
      // Inline function 'kotlin.text.plus' call
      var other = substring(this_0, 1);
      tmp = toString(tmp0) + other;
    } else {
      tmp = this_0;
    }
    return tmp;
  });
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_shown_$ref_kipsub($this$body);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('shown', 0, tmp_9, tmp_10, TextView$_set_shown_$ref_l7jsq9($this$body));
  reactiveScope($this$body, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this$reactiveScope.baj(str);
    var tmp$ret$27 = charSequenceLength(this_0) > 0;
    this_2.set(tmp$ret$27);
    return Unit_instance;
  });
  reactive($this$body, ($this$reactive) => {
    $this$body.acp($this$reactive.baj(str));
    return Unit_instance;
  });
  view_0.fbb(p_4, view_4);
  var tmp_11 = get_compact(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_5 = view_0.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
  view_0.ebb(p_5, view_5);
  view_5.xbm(false);
  view_5.jbb(get_centered(view_5), body(view_5, 'Change Amount:'));
  var tmp_12 = get_centered(view_5);
  view_5.jbb(tmp_12, renderPriceChange(view_5, false, ($this$renderPriceChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$renderPriceChange.baj(change).dh8_1;
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp0_elvis_lhs = element.u94();
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.p91(0n);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$34 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$34);
    }
    var tmp$ret$35 = sum;
    return new (MonetaryValue())(tmp$ret$35);
  }));
  view_0.fbb(p_5, view_5);
  view_0.jbb(tmp_11, view_5);
  view.fbb(p_0, view_0);
  var tmp_13 = KMutableProperty0();
  var tmp_14 = Link$_get_to_$ref_jq7esp(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('to', 0, tmp_13, tmp_14, Link$_set_to_$ref_i9gu5x(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var data = $this$reactiveScope.baj(change);
    var tmp;
    if (data.eh8_1.equals(Status_Draft_getInstance())) {
      tmp = () => new (ChangeOrderForm2())(_this__u8e3s4.jf8(), data.ch8_1.q57_1, _this__u8e3s4);
    } else {
      tmp = () => new (ChangeOrderDetails())(data.ch8_1.r57_1, data.ch8_1.q57_1, _this__u8e3s4.rgj(), _this__u8e3s4);
    }
    var tmp$ret$44 = tmp;
    this_3.set(tmp$ret$44);
    return Unit_instance;
  });
  writer.fbb(p, view);
  return writer.jbb(tmp, view);
}
function changeOrderCard$_anonymous_$_anonymous_$_anonymous_$_anonymous_$withUnit_ciuhoc(_this__u8e3s4, unit) {
  switch (_this__u8e3s4) {
    case 0:
      return null;
    case 1:
      return '' + _this__u8e3s4 + ' ' + unit;
    default:
      return '' + _this__u8e3s4 + ' ' + unit + 's';
  }
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  changeOrderCard as changeOrderCard100xlamk023hn,
};
//endregion

//# sourceMappingURL=changeOrderCards.mjs.map
